import { useState } from 'react';

const faqs = [
  {
    q: '捆绑调教安全吗？',
    a: '当遵循正确的安全守则、使用合适的道具、并在充分沟通和自愿的前提下进行时，捆绑调教是相对安全的。但任何BDSM活动都存在一定风险，这也是为什么安全教育如此重要。我们强烈建议所有初学者从安全须知开始学习，并始终以SSC原则（安全、理性、自愿）为指导。',
  },
  {
    q: '初学者应该从什么道具开始准备？',
    a: '初学者建议从棉绳或处理好的麻绳（直径6mm）入手，配上一把EMT急救剪刀是基本配置。后续可以根据需求逐步添置眼罩、软垫等辅助道具。不建议一开始就购买大量专业设备，循序渐进是最好的方式。',
  },
  {
    q: '如何与伴侣沟通捆绑调教的意愿？',
    a: '建议在轻松、私密的环境中进行坦诚的沟通。可以从分享相关文章或视频开始，了解彼此的感受和边界。重要的是强调这是双方的共同探索，任何一方都有随时说"不"的权利。使用"我很好奇..."或"你有兴趣一起了解..."等开放式表达，避免施加压力。',
  },
  {
    q: '如何选择合适的绳索材质？',
    a: '棉绳柔软亲肤，适合初学者和追求舒适度的场景；麻绳摩擦力好、结扣牢固，是传统日式绳缚的首选，但需要一定的保养；合成纤维绳（如尼龙）强度高但摩擦灼伤风险较大。建议从棉绳或处理好的麻绳开始尝试，找到最适合自己的材质。',
  },
  {
    q: '捆绑后出现绳索痕迹正常吗？',
    a: '轻微的绳索压痕是正常的，通常会在几小时到一天内消退。如果出现持续红肿、淤青或疼痛，说明捆绑过紧或压迫了神经，需要引起重视。为了减少痕迹，可以在绳索下方使用护套，并确保绳索不会过紧。如果痕迹持续超过48小时或伴有异常症状，建议寻求医疗帮助。',
  },
  {
    q: '什么是"安全词"？如何设定？',
    a: '安全词是一个事先约定好的词语或信号，当被缚者说出或做出这个信号时，所有活动必须立即停止。推荐使用"红黄绿"系统：红色代表立即停止一切活动，黄色代表放慢或调整当前操作，绿色代表一切正常继续。安全词应选择在日常对话中不会出现的词语，便于识别。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于捆绑调教，你可能想了解的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.q}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}